// Route can use the gasless (sign-to-deposit) flow. Excludes the user's gasless toggle.
export function isGaslessCapableRoute(input) {
    return input.depositMethod === 'wallet'
        && !!input.supportsGaslessDeposit
        && !!input.sourceIsSupported
        && !!input.sourceAddress;
}
